<div class="flex-grow-1">
    <div class="card mt-4">
        <div class="table-responsive">
            <table class="table table-sm card-table table-wrap" aria-labelledby="tableLabel" *ngIf="job != null">
                <thead>
                    <tr>
                        <th>Vehicle</th>
                        <th>Departed Time</th>
                        <th>From Location</th>
                        <th>Container</th>
                        <th>Journey Time</th>
                        <th>Mileage</th>
                        <th>To Location</th>
                        <th>Arrived At</th>
                        <th>Variance</th>
                        <th>Mileage Variance</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ jobModel.vehicleName }}</td>
                        <td>{{ jobModel.departedAtFormatted }}</td>
                        <td>{{ jobModel.fromLocation }}</td>
                        <td>{{ jobModel.containerId }}</td>
                        <td>{{ jobModel.journeyFormatted }}</td>
                        <td>{{ jobModel.mileageFormatted }}</td>
                        <td>{{ jobModel.toLocation }}</td>
                        <td>{{ jobModel.arrivedAtFormatted }}</td>
                        <td>{{ jobModel.variance }}</td>
                        <td>{{ jobModel.mileageVarianceFormatted }}</td>
                    </tr>
                </tbody>        
                <tbody class="list">
                    <tr>
                        <td class="h-2" colspan="8"></td>
                    </tr>
                </tbody>             
            </table>
        </div>
    </div>            
    <div  class="col-md-12 col-12 pr-1 flex-grow-1 d-flex flex-column">
          <div appSetHeight [padding]="70" class="map">
            <div class="map-container">
              <div class="map-frame" #mapdiv>
                <div id="map"></div>
              </div>
            </div>
          </div>
    </div>
</div>